<template>
  <v-card class="workspaces-list-container">
    <v-card-text class="workspace-card">
      <v-text-field
        style="padding: 0px 10px"
        v-model="searchText"
        label="Search"
        clearable
        @clear="clearSearch"
      />
      <div class="scrollable-list">
        <v-list max-height="600px" v-if="!isLoading">
          <v-list-item
            class="building-list-item"
            v-for="(item, index) in filteredBuildings"
            :key="index"
            style="border-bottom: 1px rgb(139, 137, 137) solid"
          >
            <v-list-item-action class="building-list-action">
              <v-checkbox
                class="custom-checkbox"
                color="#67a0b4"
                :input-value="isSelected(item.bd_id)"
                @change="toggleBuildingSelection(item)"
              />
            </v-list-item-action>
            <v-list-item-content class="building-list-content">
              <v-list-item-title class="list-item-title">{{
                getBuildingLabel(item)
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-progress-linear v-else :indeterminate="true" color="primary" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "BuildingsList",
  props: {
    buildings: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
  data() {
    return {
      searchText: "",
    };
  },
  computed: {
    filteredBuildings() {
      let searchText = this.searchText;
      if (searchText === null) {
        searchText = ""; // Convert null to an empty string
      }
      searchText = searchText.trim().toLowerCase(); // Remove leading/trailing spaces
      if (searchText === "") {
        return this.buildings; // Return the entire array if searchText is empty
      } else {
        return this.buildings.filter((building) => {
          const bdId = building.bd_id.toString().toLowerCase(); // Ensure bd_id is a string
          return bdId.includes(searchText);
        });
      }
    },
    selectedBuildings() {
      return this.$store.getters.getSelectedBuildings;
    },
  },
  methods: {
    ...mapActions(["fetchAllWorkspaces", "addBuilding", "deleteBuilding"]),
    isSelected(buildingId) {
      const selectedBuilding = this.selectedBuildings.find(
        (building) => building.bd_id === buildingId
      );
      return selectedBuilding ? true : false;
    },
    toggleBuildingSelection(building) {
      if (this.selectedBuildings.some(item => item.bd_id === building.bd_id)) {
        this.deleteBuilding(building.bd_id);
      } else {
        this.addBuilding(building);
      }
    },
    getBuildingLabel(building) {
      return building.bd_label ? building.bd_label : `id:${building.bd_id}`;
    },
    clearSearch() {
      this.searchText = "";
    },
  },
};
</script>
<style scoped>
.workspaces-list-container {
  width: 22%;
  height: 100%;
  margin-top: 15px;
}
.workspace-card {
  height: 100%;
  padding-bottom: 5px;
}
.scrollable-list {
  height: calc(100% - 54px);
  overflow-y: scroll;
  padding: 0px 10px;
}
.list-item-title {
  font-size: 12px;
}
.building-list-item {
  padding: 0px !important;
}
.building-list-action {
  margin-right: 0px !important;
}
.building-list-content {
  margin-left: 10px;
  text-align: start;
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/BuildingsList.vue